export const config = {
  mandatorySignIn: true,
  identityPoolRegion: process.env.REACT_APP_AUTH_COGNITO_REGION,
  userPoolId: process.env.REACT_APP_AUTH_COGNITO_USER_POOL,
  userPoolWebClientId: process.env.REACT_APP_AUTH_COGNITO_CLIENT_ID,
};

export default config;
